/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Co-assureur transmis à la création/modification d'une garantie.
 * @export
 * @interface CoAssureurCommandDto
 */
export interface CoAssureurCommandDto {
    /**
     * Compagnie co-assureur (PersonneMorale de nature CIE).
     * @type {string}
     * @memberof CoAssureurCommandDto
     */
    coAssureurPersonneMoraleId: string;
    /**
     * 
     * @type {string}
     * @memberof CoAssureurCommandDto
     */
    compteBancaireId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CoAssureurCommandDto
     */
    tauxQP?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CoAssureurCommandDto
     */
    aperition?: boolean;
}

/**
 * Check if a given object implements the CoAssureurCommandDto interface.
 */
export function instanceOfCoAssureurCommandDto(value: object): value is CoAssureurCommandDto {
    if (!('coAssureurPersonneMoraleId' in value) || value['coAssureurPersonneMoraleId'] === undefined) return false;
    return true;
}

export function CoAssureurCommandDtoFromJSON(json: any): CoAssureurCommandDto {
    return CoAssureurCommandDtoFromJSONTyped(json, false);
}

export function CoAssureurCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoAssureurCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'coAssureurPersonneMoraleId': json['coAssureurPersonneMoraleId'],
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
        'tauxQP': json['tauxQP'] == null ? undefined : json['tauxQP'],
        'aperition': json['aperition'] == null ? undefined : json['aperition'],
    };
}

export function CoAssureurCommandDtoToJSON(json: any): CoAssureurCommandDto {
    return CoAssureurCommandDtoToJSONTyped(json, false);
}

export function CoAssureurCommandDtoToJSONTyped(value?: CoAssureurCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coAssureurPersonneMoraleId': value['coAssureurPersonneMoraleId'],
        'compteBancaireId': value['compteBancaireId'],
        'tauxQP': value['tauxQP'],
        'aperition': value['aperition'],
    };
}

